import React, { useEffect, useState } from "react";
import api from "../../api";

const LibraryBooksPage = () => {
    const [categories, setCategories] = useState([]);
    const [books, setBooks] = useState([]);
    const [showCategoryInput, setShowCategoryInput] = useState(false);
    const [categoryName, setCategoryName] = useState("");
    const [form, setForm] = useState({
        category_id: "",
        book_name: "",
        author: "",
        publisher: "",
        isbn: "",
        quantity: ""
    });

    // 🔍 ফিল্টার স্টেট
    const [selectedCategory, setSelectedCategory] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    // ⚡ ইনলাইন স্টক প্যানেলের জন্য স্টেট
    const [stockAction, setStockAction] = useState({
        bookId: null,
        type: "", // 'add' অথবা 'remove'
        qty: ""
    });

    // 🔔 কাস্টম নোটিফিকেশন স্টেট
    const [alertConfig, setAlertConfig] = useState({
        show: false,
        message: "",
        type: "success"
    });

    useEffect(() => {
        fetchCategories();
        fetchBooks();
    }, []);

    const showAlert = (message, type = "success") => {
        setAlertConfig({ show: true, message, type });
        setTimeout(() => {
            setAlertConfig({ show: false, message: "", type: "success" });
        }, 3000);
    };

    const fetchCategories = async () => {
        try {
            const res = await api.get("/library/category/list");
            setCategories(res.data.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchBooks = async () => {
        try {
            const res = await api.get("/library/book/list");
            setBooks(res.data.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    // 💾 স্টক আপডেট করার মডার্ন ফাংশন
    const handleStockSubmit = async (e) => {
        e.preventDefault();
        const { bookId, type, qty } = stockAction;
        
        if (!qty || qty <= 0) {
            showAlert("❌ Please enter a valid quantity", "error");
            return;
        }

        const endpoint = type === "add" ? "/library/book/add-stock" : "/library/book/remove-stock";

        try {
            await api.post(endpoint, {
                book_id: bookId,
                quantity: qty
            });
            showAlert(`🎉 Stock ${type === "add" ? "Added" : "Removed"} Successfully!`, "success");
            setStockAction({ bookId: null, type: "", qty: "" });
            fetchBooks();
        } catch (err) {
            console.log(err);
            showAlert("❌ Failed to update stock.", "error");
        }
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const addCategory = async () => {
        if (!categoryName) return;
        try {
            await api.post("/library/category/add", {
                category_name: categoryName
            });
            showAlert("🎉 Category Added!", "success");
            setCategoryName("");
            setShowCategoryInput(false);
            fetchCategories();
        } catch (err) {
            console.log(err);
            showAlert("❌ Failed to add category.", "error");
        }
    };

    const addBook = async (e) => {
        e.preventDefault();
        try {
            await api.post("/library/book/add", form);
            showAlert("🎉 New Book Saved Successfully!", "success");
            setForm({
                category_id: "",
                book_name: "",
                author: "",
                publisher: "",
                isbn: "",
                quantity: ""
            });
            fetchBooks();
        } catch (err) {
            console.log(err);
            showAlert("❌ Failed to save book.", "error");
        }
    };

    const filteredBooks = books.filter((book) => {
        const matchesCategory = selectedCategory === "" || 
            (book.category_name && book.category_name === selectedCategory);
        
        const cleanQuery = searchQuery.toLowerCase().trim();
        const matchesText = cleanQuery === "" || 
            (book.book_name && book.book_name.toLowerCase().includes(cleanQuery)) ||
            (book.author && book.author.toLowerCase().includes(cleanQuery));

        return matchesCategory && matchesText;
    });

    return (
        <div style={styles.container}>
            <style>{hoverAndAnimationStyles}</style>

            {/* 🔔 কাস্টম নোটিফিকেশন পপআপ */}
            {alertConfig.show && (
                <div 
                    style={{
                        ...styles.popupContainer,
                        backgroundColor: alertConfig.type === "success" ? "#dcfce7" : "#fee2e2",
                        border: alertConfig.type === "success" ? "1px solid #22c55e" : "1px solid #ef4444",
                    }}
                    className="popup-animation"
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontSize: "18px" }}>{alertConfig.type === "success" ? "⭐" : "⚠️"}</span>
                        <span style={{ color: alertConfig.type === "success" ? "#14532d" : "#7f1d1d", fontWeight: "600", fontSize: "14px" }}>
                            {alertConfig.message}
                        </span>
                    </div>
                </div>
            )}

            <h2 style={styles.heading}>📚 Library Dashboard</h2>
            <hr style={styles.hr} />

            <div style={styles.card}>
                <h4 style={styles.subHeading}>Add New Book</h4>
                <form onSubmit={addBook}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Category</label>
                        <div style={styles.categoryActionRow}>
                            <select
                                name="category_id"
                                value={form.category_id}
                                onChange={handleChange}
                                style={styles.select}
                                className="styled-input"
                            >
                                <option value="">Select Category</option>
                                {categories.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.category_name}
                                    </option>
                                ))}
                            </select>
                            <button
                                type="button"
                                onClick={() => setShowCategoryInput(!showCategoryInput)}
                                style={styles.btnSecondary}
                                className="btn-secondary-hover"
                            >
                                {showCategoryInput ? "Close" : "＋ Add Category"}
                            </button>
                        </div>
                    </div>

                    {showCategoryInput && (
                        <div style={styles.inlineCategoryForm} className="fade-in">
                            <input
                                type="text"
                                placeholder="Enter Category Name"
                                value={categoryName}
                                onChange={(e) => setCategoryName(e.target.value)}
                                style={styles.input}
                                className="styled-input"
                            />
                            <button
                                type="button"
                                onClick={addCategory}
                                style={styles.btnSuccess}
                                className="btn-success-hover"
                            >
                                Save Category
                            </button>
                        </div>
                    )}

                    <div style={styles.gridForm}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Book Name</label>
                            <input
                                type="text"
                                name="book_name"
                                value={form.book_name}
                                onChange={handleChange}
                                style={styles.input}
                                className="styled-input"
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Author</label>
                            <input
                                type="text"
                                name="author"
                                value={form.author}
                                onChange={handleChange}
                                style={styles.input}
                                className="styled-input"
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Publisher</label>
                            <input
                                type="text"
                                name="publisher"
                                value={form.publisher}
                                onChange={handleChange}
                                style={styles.input}
                                className="styled-input"
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>ISBN</label>
                            <input
                                type="text"
                                name="isbn"
                                value={form.isbn}
                                onChange={handleChange}
                                style={styles.input}
                                className="styled-input"
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Quantity</label>
                            <input
                                type="number"
                                name="quantity"
                                value={form.quantity}
                                onChange={handleChange}
                                style={styles.input}
                                className="styled-input"
                            />
                        </div>
                    </div>

                    <button type="submit" style={styles.btnPrimary} className="btn-primary-hover">
                        💾 Save Book To Library
                    </button>
                </form>
            </div>

            <hr style={styles.hr} />

            <div style={styles.filterCard}>
                <h5 style={styles.filterTitle}>🔍 Search & Filter Library</h5>
                <div style={styles.filterGrid}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Filter by Category</label>
                        <select
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                            style={styles.selectDropdown}
                            className="styled-input"
                        >
                            <option value="">All Categories</option>
                            {categories.map((item) => (
                                <option key={item.id} value={item.category_name}>
                                    {item.category_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Search Book or Author</label>
                        <input
                            type="text"
                            placeholder="Type book name or author name to search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={styles.input}
                            className="styled-input"
                        />
                    </div>
                </div>
            </div>

            <h4 style={styles.subHeading}>📚 Available Book List</h4>
            <div style={styles.tableResponsive}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>ID</th>
                            <th style={styles.th}>Category</th>
                            <th style={styles.th}>Book Name</th>
                            <th style={styles.th}>Author</th>
                            <th style={styles.th}>ISBN</th>
                            <th style={styles.th}>Available Qty</th>
                            <th style={styles.th}>Total Qty</th>
                            <th style={styles.th}>Action Panel</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredBooks.length === 0 ? (
                            <tr>
                                <td colSpan="8" style={{ ...styles.td, textAlign: "center", color: "#888" }}>
                                    No books matches your search query or selected category.
                                </td>
                            </tr>
                        ) : (
                            filteredBooks.map((book) => (
                                <tr key={book.id} className="table-row-hover">
                                    <td style={styles.td}>{book.id}</td>
                                    <td style={styles.td}>{book.category_name}</td>
                                    <td style={{ ...styles.td, fontWeight: "600", color: "#1e293b" }}>{book.book_name}</td>
                                    <td style={styles.td}>{book.author}</td>
                                    <td style={styles.td}>{book.isbn}</td>
                                    
                                    {/* Available Qty */}
                                    <td style={{ ...styles.td, color: book.available_quantity > 0 ? "#16a34a" : "#dc2626", fontWeight: "bold" }}>
                                        {book.available_quantity}
                                    </td>
                                    
                                    {/* Total Qty */}
                                    <td style={{ ...styles.td, fontWeight: "600", color: "#475569" }}>
                                        {book.quantity || book.total_quantity || 0}
                                    </td>
                                    
                                    <td style={styles.td}>
                                        {stockAction.bookId === book.id ? (
                                            <form onSubmit={handleStockSubmit} style={styles.inlineStockForm} className="fade-in">
                                                <input 
                                                    type="number"
                                                    placeholder={stockAction.type === "add" ? "Add Qty" : "Remove Qty"}
                                                    value={stockAction.qty}
                                                    onChange={(e) => setStockAction({ ...stockAction, qty: e.target.value })}
                                                    style={styles.inlineStockInput}
                                                    className="styled-input"
                                                    autoFocus
                                                    required
                                                />
                                                <button type="submit" style={stockAction.type === "add" ? styles.inlineBtnAdd : styles.inlineBtnRemove}>
                                                    Confirm
                                                </button>
                                                <button type="button" onClick={() => setStockAction({ bookId: null, type: "", qty: "" })} style={styles.inlineBtnCancel}>
                                                    ✕
                                                </button>
                                            </form>
                                        ) : (
                                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                <button
                                                    onClick={() => setStockAction({ bookId: book.id, type: "add", qty: "" })}
                                                    style={styles.actionBtnSuccess}
                                                    className="btn-success-hover"
                                                >
                                                    ＋ Stock
                                                </button>
                                                <button
                                                    onClick={() => setStockAction({ bookId: book.id, type: "remove", qty: "" })}
                                                    style={styles.actionBtnDanger}
                                                    className="btn-action-hover"
                                                >
                                                    － Stock
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: "1240px",
        margin: "40px auto",
        padding: "0 24px",
        fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        color: "#334155",
        backgroundColor: "#f8fafc",
        position: "relative"
    },
    popupContainer: {
        position: "fixed",
        top: "24px",
        right: "24px",
        zIndex: 9999,
        padding: "14px 20px",
        borderRadius: "8px",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        minWidth: "250px"
    },
    heading: {
        fontSize: "26px",
        fontWeight: "700",
        color: "#0f172a",
        marginBottom: "10px"
    },
    subHeading: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#334155",
        marginBottom: "18px"
    },
    hr: {
        border: "0",
        height: "1px",
        background: "#e2e8f0",
        margin: "25px 0"
    },
    card: {
        background: "#ffffff",
        padding: "26px",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e2e8f0",
        marginBottom: "25px"
    },
    filterCard: {
        background: "#ffffff",
        padding: "22px",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        marginBottom: "25px"
    },
    filterTitle: {
        margin: "0 0 12px 0",
        fontSize: "15px",
        fontWeight: "600",
        color: "#1e293b"
    },
    filterGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: "16px"
    },
    formGroup: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
    },
    label: {
        fontSize: "13px",
        fontWeight: "600",
        color: "#475569",
        marginBottom: "6px"
    },
    input: {
        padding: "10px 14px",
        fontSize: "14px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        outline: "none",
        backgroundColor: "#fff",
        width: "100%",
        boxSizing: "border-box"
    },
    select: {
        padding: "10px 14px",
        fontSize: "14px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        outline: "none",
        backgroundColor: "#fff",
        flex: "1",
        cursor: "pointer"
    },
    selectDropdown: {
        padding: "10px 14px",
        fontSize: "14px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        outline: "none",
        backgroundColor: "#fff",
        width: "100%",
        boxSizing: "border-box",
        cursor: "pointer"
    },
    categoryActionRow: {
        display: "flex",
        gap: "12px",
        alignItems: "center"
    },
    inlineCategoryForm: {
        display: "flex",
        gap: "12px",
        marginBottom: "20px",
        backgroundColor: "#f1f5f9",
        padding: "12px",
        borderRadius: "8px",
        alignItems: "center"
    },
    gridForm: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "16px",
        marginTop: "12px"
    },
    btnPrimary: {
        backgroundColor: "#2563eb",
        color: "#ffffff",
        padding: "11px 24px",
        fontSize: "14px",
        fontWeight: "600",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        marginTop: "15px",
        width: "100%"
    },
    btnSecondary: {
        backgroundColor: "#64748b",
        color: "#ffffff",
        padding: "10px 16px",
        fontSize: "13px",
        fontWeight: "600",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        whiteSpace: "nowrap"
    },
    btnSuccess: {
        backgroundColor: "#16a34a",
        color: "#ffffff",
        padding: "10px 16px",
        fontSize: "13px",
        fontWeight: "600",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        whiteSpace: "nowrap"
    },
    actionBtnSuccess: {
        backgroundColor: "#16a34a",
        color: "#ffffff",
        padding: "6px 12px",
        fontSize: "13px",
        fontWeight: "600",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "inline-flex",
        alignItems: "center"
    },
    actionBtnDanger: {
        backgroundColor: "#dc2626",
        color: "#ffffff",
        padding: "6px 12px",
        fontSize: "13px",
        fontWeight: "600",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "inline-flex",
        alignItems: "center"
    },
    inlineStockForm: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        backgroundColor: "#f1f5f9",
        padding: "4px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1"
    },
    inlineStockInput: {
        width: "80px",
        padding: "5px 8px",
        fontSize: "13px",
        borderRadius: "4px",
        border: "1px solid #cbd5e1",
        outline: "none"
    },
    inlineBtnAdd: {
        backgroundColor: "#16a34a",
        color: "#fff",
        border: "none",
        padding: "5px 10px",
        fontSize: "12px",
        fontWeight: "600",
        borderRadius: "4px",
        cursor: "pointer"
    },
    inlineBtnRemove: {
        backgroundColor: "#dc2626",
        color: "#fff",
        border: "none",
        padding: "5px 10px",
        fontSize: "12px",
        fontWeight: "600",
        borderRadius: "4px",
        cursor: "pointer"
    },
    inlineBtnCancel: {
        backgroundColor: "#e2e8f0",
        color: "#475569",
        border: "none",
        padding: "5px 8px",
        fontSize: "12px",
        borderRadius: "4px",
        cursor: "pointer"
    },
    tableResponsive: {
        overflowX: "auto",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e2e8f0"
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "left",
        fontSize: "14px"
    },
    th: {
        backgroundColor: "#f8fafc",
        color: "#475569",
        fontWeight: "600",
        padding: "14px 16px",
        borderBottom: "2px solid #e2e8f0"
    },
    td: {
        padding: "12px 16px",
        borderBottom: "1px solid #f1f5f9",
        color: "#334155",
        verticalAlign: "middle"
    }
};

const hoverAndAnimationStyles = `
    .styled-input:focus {
        border-color: #2563eb !important;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
    }
    .btn-primary-hover:hover {
        background-color: #1d4ed8 !important;
        transform: translateY(-1px);
    }
    .btn-secondary-hover:hover {
        background-color: #475569 !important;
    }
    .btn-success-hover:hover {
        background-color: #15803d !important;
    }
    .btn-action-hover:hover {
        background-color: #b91c1c !important;
    }
    .table-row-hover:hover {
        background-color: #f8fafc;
        transition: background-color 0.2s ease;
    }
    .fade-in {
        animation: fadeIn 0.2s ease-in-out;
    }
    .popup-animation {
        animation: slideIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-3px); }
        to { opacity: 1; transform: translateY(0); }
    }
    @keyframes slideIn {
        from { opacity: 0; transform: translateY(-15px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;

export default LibraryBooksPage;